import {
    REQUEST_ACTIVITIES_SETTINGS,
    RECEIVE_ACTIVITIES_SETTINGS,
    UPDATE_ACTIVITIES_SETTINGS,
    ERROR_ACTIVITIES_SETTINGS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"


export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_ACTIVITIES_SETTINGS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_ACTIVITIES_SETTINGS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case UPDATE_ACTIVITIES_SETTINGS:
            const data = state.data
            let index = null
            if(data.results){
                if(action.updateType == "delete"){
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                }else{
                    index = data.results.findIndex(item => item.id == action.id)
                    if(index > -1){
                        data.results[index] = action.payload
                    }else{
                        data.results.unshift(action.payload)
                    }
                }
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_ACTIVITIES_SETTINGS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}